var imgArr = [

  "https://cdn.shopify.com/s/files/1/0728/7508/2015/files/1_8f9692da-be9d-46dc-b002-4b44e9f97fdf.png?v=1736819685",
  "https://cdn.shopify.com/s/files/1/0728/7508/2015/files/2_6d26cec3-c342-4252-86f1-4449f3080e63.png?v=1736819685",
  "https://cdn.shopify.com/s/files/1/0728/7508/2015/files/3_92621abb-ec36-4647-ae3e-2131c88fc790.png?v=1736819685",
  "https://cdn.shopify.com/s/files/1/0728/7508/2015/files/6.png?v=1736819685",
        'https://cdn.shopify.com/s/files/1/0728/7508/2015/files/2_6d26cec3-c342-4252-86f1-4449f3080e63.png?v=1736819685',
  'https://cdn.shopify.com/s/files/1/0728/7508/2015/files/4_f85be608-5a48-4603-b28e-ff92048749f9.png?v=1736819685',
  "https://cdn.shopify.com/s/files/1/0728/7508/2015/files/5.png?v=1736819685",
  
]
function mainRender() {
$(function () {
$('#root').css('zoom', 'normal')
let scale = document.body.clientWidth / 1080
$('#root').css('zoom', scale)

window.addEventListener(
  'resize',
  (function () {
    var timer
    return function () {
      if (timer) clearTimeout(timer)
      timer = setTimeout(function () {
        $('#root').css('zoom', 'normal')
        let scale = document.body.clientWidth / 1080
        $('#root').css('zoom', scale)
      }, 100)
    }
  })()
)
// 倒计时
// 生成随机时间
function generateRandomTime() {
  var hours = Math.floor(Math.random() * 15) + 1
  var minutes = Math.floor(Math.random() * 60)
  var seconds = Math.floor(Math.random() * 60)
  //总共的毫秒数
  var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

  return targetTime
}
function TimeDown(value) {
  //倒计时的总秒数
  var totalSeconds = parseInt(value / 1000)
  //取模（余数）
  var modulo = totalSeconds % (60 * 60 * 24)
  //小时数
  var hours = Math.floor(modulo / (60 * 60))
  modulo = modulo % (60 * 60)
  //分钟
  var minutes = Math.floor(modulo / 60)
  //秒
  var seconds = modulo % 60

  hours = hours.toString().length == 1 ? '0' + hours : hours
  minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
  seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

  //输出到页面
  $('.sp_hour').html(hours)
  $('.sp_minute').html(minutes)
  $('.sp_second').html(seconds)
  //延迟一秒执行自己
  if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
  } else {
    setTimeout(function () {
      TimeDown(value - 1000)
    }, 1000)
  }
}
TimeDown(generateRandomTime())
new Swiper('.mySwiper', {
  loop: true,
  centeredSlides: true,
  spaceBetween: 20,
  slidesPerView: 'auto',
  freeMode: true,
  speed: 20000, //匀速时间
  autoplay: {
    delay: 0,
    stopOnLastSlide: false,
    disableOnInteraction: false,
  },
})
// new Swiper('#swiper2', {
//   loop: true,
//   centeredSlides: true,
//   spaceBetween: 0,
//   slidesPerView: 1.7,
//   autoplay: {
//     delay: 3000,
//     stopOnLastSlide: false,
//     disableOnInteraction: false,
//   },
//   pagination: {
//     el: '.swiper-pagination',
//     clickable: true,
//   },
// })
// 动画
$('#goods-image_header_1').show()
$('#goods-image_header_2').hide()
let header_flag = false
setInterval(() => {
  header_flag = !header_flag
  if (header_flag) {
    $('#goods-image_header_1').hide()
    $('#goods-image_header_2').show()
  } else {
    $('#goods-image_header_1').show()
    $('#goods-image_header_2').hide()
  }
}, 1000)


// style选项
let typeOptions = $('.option')
// 切换选项
typeOptions.click(function () {
  $(this).addClass('active').siblings().removeClass('active')
  let color = $('#color div.active').index()
  const type = $('#type div.active').index()

  
  $('.top-product>img').attr('src', imgArr[color])
  console.log(type+color*3)
})
// style选项
$('.cart-btn').click(function () {
  $(this).children('img').addClass('on')
  setTimeout(function () {
    $('.cart-btn').children('img').removeClass('on')
  }, 500)
  $('.sp-header-top .sp-cart').addClass('on')
  setTimeout(function () {
    $('.sp-header-top .sp-cart').removeClass('on')
  }, 500)
})
function getCur(){
let color = $('#color div.active').attr('data-val')
const type = $('#type div.active').attr('data-val')
return prod.find(item=> item.option1==color)
}
function changePrice(){
let num = $('#calcNumber').val()
let price = (getCur().price*num / 100).toFixed(2)
let compare = (getCur().compare_at_price*num / 100).toFixed(2)
// price = (price + '').replace('.', ',')
// compare = (compare + '').replace('.', ',')
$('#new').html(price)
$('#old').html(compare)
let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
$(".product-part .sp-price3 span").html(off_font);
}
// 数字框
$('.reduce').click(function () {
  let input = $(this).siblings('input')[0]
  let num = Number(input.value) - 1
  if(num>0){
    input.value = num
  changePrice()
  }
  
})
$('.add').click(function () {
  let input = $(this).siblings('input')[0]
  let num = Number(input.value) + 1
  input.value = num
  changePrice()
})
  $('.sp-btn-style').click(function(){
let num = $('#calcNumber').val()
window.location.href = '/cart/' + getCur().id + ':' + num
})

$('.product-part .cart-btn').click(function () {
  var img = $('.top-product>img')
  var data = {
    id: getCur().id,
    quantity: $('#calcNumber').val(),
  };
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    success: function () {
      $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
        $("#cardNum").html(result.item_count);
        $('.sp-cart .num').css('background', '#cf0101')
      });
    },
    dataType: "json",
  });
  var flyer = img[0].cloneNode(true)
  flyer.classList.add('sp_clone')
  var offset = $('.sp-cart')[0].getBoundingClientRect()
  $('.product-part').append(flyer)
  $('.sp_clone').css({
    width: img.width(),
    height: img.height(),
    position: 'fixed',
    top: img[0].offsetTop,
    left: img.offset().left,
    'z-index': '9999',
  })

  let finish = $('.sp-cart')
  $('.sp_clone').animate(
    {
      top: finish[0].offsetTop + 120,
      left: finish[0].offsetLeft + finish.width() / 2,
      width: 50, // 结束时的大小，根据需要调整
      height: 50, // 结束时的大小，根据需要调整
      opacity: 0.4,
      'z-index': '9999',
    },
    500,
    'linear',
    function () {
      $(this).animate(
        {
          width: 0,
          height: 0,
          opacity: 0,
        },
        0,
        function () {
          $('.sp-header-top .sp-cart').addClass('sp-shake')
          setTimeout(function () {
            $('.sp-header-top .sp-cart').removeClass('sp-shake')
          }, 400)
          $(this).detach()
        }
      )
    }
  )
})
})
function lazyLoadImages() {
// 懒加载
const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
const config = {
  rootMargin: '0px 0px 1300px 0px',
  threshold: 0,
}

const lazyLoadObserver = new IntersectionObserver(function (
  entries,
  observer
) {
  entries.forEach(function (entry) {
    if (entry.isIntersecting) {
      // 当图片进入视口时
      const image = entry.target
      const dataSrc = image.getAttribute('data-src')
      image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
      lazyLoadObserver.unobserve(image) // 停止观察该图片
    }
  })
},
config)

images.forEach(function (image) {
  lazyLoadObserver.observe(image) // 开始观察每个图片
})
}

function preloadImages(imageArray) {
// 预加载
// 检查数组数据结构
if (Array.isArray(imageArray[0])) {
  // 处理二维数组
  imageArray.forEach((subArray) => {
    subArray.forEach((url) => {
      const img = new Image()
      img.src = url
    })
  })
} else {
  // 处理一维数组
  imageArray.forEach((url) => {
    const img = new Image()
    img.src = url
  })
}
}

document.addEventListener('DOMContentLoaded', function () {
lazyLoadImages()

preloadImages(imgArr)
// preloadImages(imagesTwoDim)

// 找到所有跳转套餐的锚点链接
var links = document.querySelectorAll('a[href^="#shopping"]')
links.forEach(function (link) {
  link.addEventListener('click', function (event) {
    event.preventDefault() // 阻止默认的跳转行为
    // var targetElement = document.getElementById('shopping');
    // if (targetElement) {
    //     targetElement.scrollIntoView({ behavior: 'smooth' });
    // } // 方式一
    const targetElement = document.getElementById('shopping') // 获取跳转目标节点
    const offsetTop =
      targetElement.offsetTop -
      $('.sp-header-top').height() -
      $('.time-part').height()
    window.scroll({
      top: (offsetTop+250) * $('div#root').css('zoom'),
      behavior: 'smooth', // 使用 smooth 实现平滑滚动
    }) // 方式二
  })
})
})

// IOS字体多了间距的处理 给节点添加 sp_system 类名
// 判断当前用户是安卓端还是iOS端
var userAgent = navigator.userAgent || navigator.vendor || window.opera
var isAndroid = /android/i.test(userAgent)
var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

if (isAndroid) {
console.log('Android')
} else if (isIOS) {
console.log('iOS')
} else if (isPC) {
console.log('PC')
} else {
$('.sp_system').css('letter-spacing', '-4px')
}
}

mainRender()
